module.exports = __webpack_public_path__ + "img/庆祝.e2bbefee.png";